import { CircularProgress } from '@mui/joy'
import { Stack } from '@mui/material'
import { usePermissions } from '~/entities/common/viewer'
import { AuditsModal } from '~/widgets/common/AuditsModal'
import { RentalContractCreated } from '~/widgets/common/Driver/RentalContractControls'
import { ButtonDebtExtra } from '../ButtonDebtExtra'
import { ForceApprove } from '../ForceApprove'

type ActionButtonsProps = {
  driverId: string
  loading: boolean
}
export function ActionButtons({ driverId, loading }: ActionButtonsProps) {
  const { canAuditsView } = usePermissions()

  if (loading) return <CircularProgress size='sm' />

  return (
    <Stack spacing={2} direction='row' alignItems='center'>
      <ForceApprove />

      {canAuditsView && <AuditsModal auditableId={driverId} />}
      <RentalContractCreated />

      <ButtonDebtExtra />
    </Stack>
  )
}
